import React from 'react';
import { steps } from '../data/howItWorks';
export function HowItWorks() {
  return <section aria-labelledby="how-title" className="bg-canvas" data-id="element-130" data-mp="7sllqmrnxfls">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" style={{
      paddingTop: "11px",
      paddingBottom: "9px"
    }} data-id="element-131" data-mp="7qshtf8fp9hh">
        <div className="text-center" data-id="element-132" data-mp="3u03gbafszpmg">
          <h2 id="how-title" className="font-display text-3xl font-black text-ink sm:text-4xl" data-id="element-133" data-mp="3u14s5h4n8g58">
            How it works
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-base text-muted" data-id="element-134" data-mp="ll1tg0vie1t1">
            It’s a structured instruction system optimized for real estate workflows.
          </p>
        </div>

        <ol className="relative mt-14 grid gap-10 lg:grid-cols-5 lg:gap-6" data-id="element-135" data-mp="crgh0o6tgwms">
          <span className="absolute left-[19px] top-5 bottom-5 w-px bg-cyan lg:left-5 lg:right-5 lg:top-5 lg:bottom-auto lg:h-px lg:w-auto" aria-hidden="true" data-id="element-136" data-mp="gsi6weeufwc3" />
          {steps.map(s => <li key={s.n} className="relative flex gap-5 lg:flex-col lg:gap-0" data-id="element-137" data-mp="199m9dwkpoo88">
              <span className="relative z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-cyan bg-white font-display text-sm font-black text-ink" data-id="element-138" data-mp="2rlnxvcwcamxv">
                {s.n}
              </span>
              <div className="lg:mt-5" data-id="element-139" data-mp="31bzfg28y4un8">
                <h3 className="font-display text-base font-extrabold text-ink" data-id="element-140" data-mp="31d22u0728eye">{s.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-muted" data-id="element-141" data-mp="2wj69xc5nlia3">{s.body}</p>
                {s.chips && <ul className="mt-3 flex flex-wrap gap-1.5" data-id="element-142" data-mp="3aaunzkzgqgtp">
                    {s.chips.map(c => <li key={c} className={s.chipStyle === 'bracket' ? 'rounded bg-gold-soft px-1.5 py-0.5 font-mono text-[11px] font-semibold text-gold-ink' : 'rounded-full border border-line bg-white px-2.5 py-0.5 text-xs font-medium text-ink'} data-id="element-143" data-mp="369is4xpzwzd2">
                        {c}
                      </li>)}
                  </ul>}
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}